import type { ICellRendererParams } from 'ag-grid-community';
import { SensitivityContainer } from 'components/Blotters/sensitivity/sensitivity';
import { useShouldReloadSensitivityDataOnMount } from 'components/Blotters/sensitivity/useShouldReloadSensitivityDataOnMount';
import { IBlotterQuoteItem } from 'models/IBlotterItem';

const rowSnapshotByQuoteId = new Map<string, IBlotterQuoteItem>();

export function SensitivityDetailCellRenderer({ data }: ICellRendererParams<IBlotterQuoteItem>) {
  const shouldRefresh = useShouldReloadSensitivityDataOnMount(data, rowSnapshotByQuoteId);

  return (
    <SensitivityContainer
      className="w-100"
      paddingLeft={115}
      referenceQuoteId={data?.quoteId!}
      shouldRefresh={shouldRefresh}
    />
  );
}
